<template>
  <div
    class="page-boxed page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-sidebar-closed-hide-logo">
    <div>
      <PartnerHeader></PartnerHeader>
      <div class="clearfix"></div>
      <div class="">
        <div class="page-container">
          <div class="page-sidebar-wrapper">
            <PartnerSide></PartnerSide>
          </div>
          <div class="page-content-wrapper">

            <div class="page-content ">
              <router-view name="partner"></router-view>
            </div>
            <PartnerFooter></PartnerFooter>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import PartnerFooter from '../components/partner/Footer.vue'
import PartnerHeader from '../components/partner/Header.vue'
import PartnerSide from '../components/partner/Side.vue'
import VueHead from 'vue-head'

Vue.use(VueHead)
export default {
  head: {
    link: [
      // {rel: 'stylesheet', href: '/static/wcu/bootstrap/css/bootstrap.min.css'},
      {rel: 'stylesheet', href: '/static/wcu/css/components.css'},
      {rel: 'stylesheet', href: '/static/wcu/css/layout.css'},
      {rel: 'stylesheet', href: '/static/wcu/css/themes/grey.css'},
      {rel: 'stylesheet', href: '/static/wcu/css/custom-fontawesome.css'},
      {rel: 'stylesheet', href: '/static/wcu/lib/simple-line-icons/simple-line-icons.min.css'}
    ]
  },
  components: {PartnerFooter, PartnerSide, PartnerHeader}
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerPanel.vue